import { combineReducers } from "redux";

// Reducers
import articles from "./articleReducer";
import pricing from "./pricingReducer";
import faq from "./faqReducer";
import pages from "./pagesReducer";

export default combineReducers({
    articles,
    pricing,
    faq,
    pages
});



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js